import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IInnerStyledHeadingBlok } from './inner-styled-heading.model';
import { TailwindService } from '@seven1/angular-storyblok/tailwind'

@Component({
    selector: 'app-inner-styled-heading',
    imports: [CommonModule],
    templateUrl: './inner-styled-heading.component.html',
    styleUrl: './inner-styled-heading.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'getDisplayClasses()',
    },
})
export class InnerStyledHeadingComponent {
    private _tailwind = inject(TailwindService)
    block = input.required<IInnerStyledHeadingBlok>();

    // @Input({ transform: numberAttribute }) public level: AppHeadingLevel = 1;
    //
    // @Input() public textContentBeginning: string = 'This is ';
    // @Input() public textContent: string = 'a Heading';
    // @Input() public textContentEnding: string = ' Component';
    //
    // @Input() public decorationColor: AppTextColors = 'inherit';
    // @Input() public decorationColorTablet: AppTextColors = 'unset';
    // @Input() public decorationColorDesktop: AppTextColors = 'unset';
    // @Input() public align: AppContainerAlign = 'unset';
    // @Input() public alignTablet: AppContainerAlign = 'unset';
    // @Input() public alignDesktop: AppContainerAlign = 'unset';
    // @Input() public innerFontSize: AppFontSizes = 'unset';
    // @Input() public innerFontSizeTablet: AppFontSizes = 'unset';
    // @Input() public innerFontSizeDesktop: AppFontSizes = 'unset';
    // @Input() public innerFontWeight: AppFontWeights = 'unset';
    // @Input() public innerFontWeightTablet: AppFontWeights = 'unset';
    // @Input() public innerFontWeightDesktop: AppFontWeights = 'unset';

    // //Mobile inputs
    // @Input() public fontSize: AppFontSizes = 'unset';
    // @Input() public fontWeight: AppFontWeights = 'unset';
    // @Input() public color: AppTextColors = 'inherit';
    // @Input() public textAlign: AppTextAlign = 'unset';
    // @Input() public letterSpacing: AppTextTracking = 'unset';
    // @Input() public textTransform: AppTextTransforms = 'unset';
    // @Input() public marginY: AppSpacingSizes = 'unset';
    // @Input() public marginTop: AppSpacingSizes = 'unset';
    // @Input() public marginBottom: AppSpacingSizes = 'unset';
    // @Input() public marginX: AppSpacingSizes = 'unset';
    // @Input() public marginLeft: AppSpacingSizes = 'unset';
    // @Input() public marginRight: AppSpacingSizes = 'unset';
    // @Input() public italic: AppTextItalic = 'unset';
    // @Input() public display: AppDisplayTypes = 'unset';
    // @Input() public maxWidth: AppMaxFixedWidths = '20rem';
    //
    // // Tablet inputs
    // @Input() public fontSizeTablet: AppFontSizes = 'unset';
    // @Input() public fontWeightTablet: AppFontWeights = 'unset';
    // @Input() public colorTablet: AppTextColors = 'unset';
    // @Input() public textAlignTablet: AppTextAlign = 'unset';
    // @Input() public letterSpacingTablet: AppTextTracking = 'unset';
    // @Input() public textTransformTablet: AppTextTransforms = 'unset';
    // @Input() public marginYTablet: AppSpacingSizes = 'unset';
    // @Input() public marginTopTablet: AppSpacingSizes = 'unset';
    // @Input() public marginBottomTablet: AppSpacingSizes = 'unset';
    // @Input() public marginXTablet: AppSpacingSizes = 'unset';
    // @Input() public marginLeftTablet: AppSpacingSizes = 'unset';
    // @Input() public marginRightTablet: AppSpacingSizes = 'unset';
    // @Input() public italicTablet: AppTextItalic = 'unset';
    // @Input() public displayTablet: AppDisplayTypes = 'unset';
    // @Input() public maxWidthTablet: AppMaxFixedWidths = 'unset';
    //
    // // Desktop inputs
    // @Input() public fontSizeDesktop: AppFontSizes = 'unset';
    // @Input() public fontWeightDesktop: AppFontWeights = 'unset';
    // @Input() public colorDesktop: AppTextColors = 'unset';
    // @Input() public textAlignDesktop: AppTextAlign = 'unset';
    // @Input() public letterSpacingDesktop: AppTextTracking = 'unset';
    // @Input() public textTransformDesktop: AppTextTransforms = 'unset';
    // @Input() public marginYDesktop: AppSpacingSizes = 'unset';
    // @Input() public marginTopDesktop: AppSpacingSizes = 'unset';
    // @Input() public marginBottomDesktop: AppSpacingSizes = 'unset';
    // @Input() public marginXDesktop: AppSpacingSizes = 'unset';
    // @Input() public marginLeftDesktop: AppSpacingSizes = 'unset';
    // @Input() public marginRightDesktop: AppSpacingSizes = 'unset';
    // @Input() public italicDesktop: AppTextItalic = 'unset';
    // @Input() public displayDesktop: AppDisplayTypes = 'unset';
    // @Input() public maxWidthDesktop: AppMaxFixedWidths = 'unset';

    getAllClasses = computed(() => {
        const block = this.block();
        return [
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getSpacingClasses({
                marginX: block.align,
                marginXTablet: block.alignTablet,
                marginXDesktop: block.alignDesktop,
            }),
            ...this._tailwind.getSizeClasses(block),
            ...this._tailwind.getTypographyClasses(block),
        ];
    });

    getInnerClasses = computed(() => {
        const block = this.block();
        return this._tailwind.getTypographyClasses({
            fontSize: block.innerFontSize,
            fontSizeTablet: block.innerFontSizeTablet,
            fontSizeDesktop: block.innerFontSizeDesktop,
            color: block.decorationColor,
            colorTablet: block.decorationColorTablet,
            colorDesktop: block.decorationColorDesktop,
            fontWeight: block.innerFontWeight,
            fontWeightTablet: block.innerFontWeightTablet,
            fontWeightDesktop: block.innerFontWeightDesktop,
        });
    })

    getDisplayClasses() {
        return this._tailwind.getDisplayClasses(this.block())
    }
}
